/**
 * The plan's recent wall thicknesses, one click each.
 *
 * Shown wherever a thickness is set — arming the wall tool, and editing a wall
 * already drawn — because the value someone reaches for next is nearly always
 * one they have already used on this plan. The list itself is session-scoped
 * (`useWallThickness`); this only renders it.
 *
 * One value is not a choice, so the row appears at two.
 */
import { useTranslation } from 'react-i18next'
import { Button } from '../ui/button'

interface WallThicknessChipsProps {
    /** Most recent first — see `useWallThickness`. */
    recent: number[]
    /** The value in effect here: the armed one, or the selected wall's. */
    active: number
    onPick: (mm: number) => void
}

export function WallThicknessChips(props: WallThicknessChipsProps) {
    const { t } = useTranslation('assets')
    if (props.recent.length < 2) return null

    return (
        <div className="flex flex-wrap items-center gap-1" data-testid="plan-editor-wall-thickness-recent">
            <span className="text-[11px] text-muted-foreground">{t('planEditor.thickness_recent')}</span>
            {props.recent.map((value) => (
                <Button
                    key={value}
                    variant={value === props.active ? 'default' : 'outline'}
                    size="sm"
                    className="h-6 px-2 text-xs"
                    aria-pressed={value === props.active}
                    data-testid={`plan-editor-wall-thickness-${value}`}
                    onClick={() => props.onPick(value)}
                >
                    {value}
                </Button>
            ))}
        </div>
    )
}
